import React, { useState} from 'react'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import "./../components.css"



const DeleteDialog = ({ dilogvisible, setDilogvisibleVisible, deletefucton,dialogHeader,dialogContents}) => {

  

    const footerContent = (
        <div>
            <Button label="No" icon="pi pi-times" className="px-3 py-1 text-sm p-button-text" onClick={() => setDilogvisibleVisible(false)}  />
            <Button label="Yes" icon="pi pi-check" className='px-3 py-1 text-sm' onClick={() => {setDilogvisibleVisible(false); deletefucton();}}  autoFocus />
        </div>
    );

  return (
    <div className="card flex justify-content-center">
          <Dialog header={ dialogHeader}  visible={dilogvisible} style={{ width: '25vw' }} onHide={() => setDilogvisibleVisible(false)} footer={footerContent}>
              { dialogContents}
    </Dialog>
</div>
  )
}

export default DeleteDialog